import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import Switch from "@mui/material/Switch";
import UsuarioImei from "./Imei/UsuarioImei";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ModulosScreen from "./Menus/ModulosScreen";
import LineasVentasScreen from "./LineasVenta/LineasVentaScreen";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { EnviarNotificacion } from "../../helpers/EnviarNotificacion";
import PasswordIcon from "@mui/icons-material/Password";
import AppSettingsAltIcon from "@mui/icons-material/AppSettingsAlt";
import { Settings } from "@mui/icons-material";

const PermisosUsuariosSeleccion = () => {
  const { state } = useLocation();
  const history = useHistory();

  const [mostrarImei, setMostrarImei] = useState(false);
  const [mostrarMenu, setMostrarMenu] = useState(false);
  const [mostrarLineas, setMostrarLineas] = useState(false);

  const onMostrarMenu = () => {
    setMostrarMenu(true);
    setMostrarImei(false);
    setMostrarLineas(false);
  };

  const onAgregarImei = () => {
    setMostrarImei(true);
    setMostrarMenu(false);
    setMostrarLineas(false);
  };

  const onMostrarLineas = () => {
    setMostrarLineas(true)
    setMostrarImei(false);
    setMostrarMenu(false);
  };

  const onRestablecerContraseña = () => {
    //   setLoader({ ...loader, mostrar: true });
    Swal.fire({
      title: "RESTABLECER CONTRASEÑA?",
      text: "Seguro que deseas restablecer la contraseña?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "No, Regresar",
      confirmButtonText: "Si, Restablecer contraseña!",
    }).then((result) => {
      if (result.isConfirmed) {
        const post = {
          idusuario: state.idusuario,
          password: "",
          bloqueado: 0,
          intentos: 0,
          codigoautenticacion: 0,
        };
        request
          .post(`RegistrarUsuario`, post)
          .then(async () => {
            //   setLoader({ ...loader, mostrar: false });

            await Swal.fire({
              title: "RESTABLECER CONTRASEÑA",
              text: "Contraseña restablecida con exito",
              icon: "success",
              customClass: {
                container: "mi-superpoop",
              },
            });

            // history.push("/Permisos/PermisosUsuarios");
          })
          .catch((error) => {
            // setLoader({ ...loader, mostrar: false });
            Swal.fire("PERMISOS", JSON.stringify(error), "error");
          });
      }
    });
  };

  const onEnviarNotificacion = () => {
    const fechaLocal = new Date();
    const fechaFormateada = fechaLocal.getFullYear() + '-' +
      String(fechaLocal.getMonth() + 1).padStart(2, '0') + '-' +
      String(fechaLocal.getDate()).padStart(2, '0') + ' ' +
      String(fechaLocal.getHours()).padStart(2, '0') + ':' +
      String(fechaLocal.getMinutes()).padStart(2, '0') + ':' +
      String(fechaLocal.getSeconds()).padStart(2, '0');

    EnviarNotificacion({
      titulo: "Humaya Digital",
      mensaje:
        "Empieza el mes con el nuevo listado de precios Maquinaria Seminueva. Ingresa para ver",
      // redireccion: "ListadoPreciosPA"
      redireccion: "BuscadorClientes",
      idencabezado: 8,
      fecha_evento: fechaFormateada // ← Aquí se asigna la fecha y hora actual
    });
  };

  const onHome = () => {
    history.push("/Permisos/PermisosUsuarios");
  };

  return (
    <PlantillaScreen
      titulo={`PERFIL DE ${state.usuario.toUpperCase()}`}
      className_main={1}
      className={"permisos-usuarios-main-screen"}
    >
      <div className="permisos-usuarios-usuario-options">
        <div className="permisos-usuarios-botones-main-container">
          <div className="permisos-usuarios-botones-usuarios-opciones">
            <button
              className="permisos-usuarios-botones"
              onClick={() => onRestablecerContraseña()}
            >
              <div>
                <PasswordIcon />
                Restablecer Contraseña
              </div>
              <ArrowForwardIosIcon />
            </button>
          </div>
          <div className="permisos-usuarios-botones-usuarios-opciones">
            <button
              className="permisos-usuarios-botones"
              onClick={() => onMostrarMenu()}
            >
              <div>
                <Settings />
                Modificar Permisos
              </div>
              <ArrowForwardIosIcon />
            </button>
          </div>
          <div className="permisos-usuarios-botones-usuarios-opciones">
            <button
              className="permisos-usuarios-botones"
              onClick={() => onMostrarLineas()}
            >
              <div>
                <Settings />
                Permisos de Lineas de Venta
              </div>
              <ArrowForwardIosIcon />
            </button>
          </div>
          <div className="permisos-usuarios-botones-usuarios-opciones">
            <button
              className="permisos-usuarios-botones"
              onClick={() => onAgregarImei()}
            >
              <div>
                <AppSettingsAltIcon />
                Agregar IMEI
              </div>
              <ArrowForwardIosIcon />
            </button>
          </div>
        </div>
        <div className="permisos-usuarios-menu-container">
          {mostrarImei === true ? (
            <UsuarioImei
              idusuario={state.idusuario}
              setMostrarImei={setMostrarImei}
            />
          ) : (
            <div />
          )}
          {mostrarMenu === true ? (
            <ModulosScreen idusuario={state.idusuario} />
          ) : (
            <div />
          )}
          {mostrarLineas === true ? (
            <LineasVentasScreen idusuario={state.idusuario} />
          ) : (
            <div />
          )}
        </div>
        <div>
          <div className="inicio" onClick={() => onHome()}>
            <ArrowBackIcon /> Regresar
          </div>
        </div>
      </div>
    </PlantillaScreen>
  );
};

export default PermisosUsuariosSeleccion;
